import { observer } from 'mobx-react-lite';
import Button from '../../Globle/Button';
import CustomDropdown from '../../Globle/CustomDropdown';
import {
    closetColor,
    doorColorOptions,
    doorStyleOptions,
    drawerColorOptions,
    drawerStyleOptions,
    handleColorOptions,
    handleStyleOptions,
    rodColorOptions,
} from '../../../__utils/UiConst';
import { Checkbox } from 'antd';

const ClosetStyle = observer(({ Form, form, onNext }) => {
    return (
        <div className="collapse-content relative h-[calc(100dvh-150px)]">
            <h1 className="text-[32px] font-favorit font-[700] leading-[40px] pb-[24px]">
                Choose closet’ style
            </h1>
            <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                Closet
            </h1>
            <div className="closet-style-content">
                <Form.Item
                    name="color"
                    label={'Color'}
                    className="custom-form-item mt-[8px]">
                    <CustomDropdown
                        className="mt-2"
                        rootClassName="h-[48px]"
                        popupClassName="!h-[120px]"
                        isColor={true}
                        value={form.getFieldValue('color')}
                        options={closetColor}
                        onChange={(value) => {
                            form.setFieldValue('color', value);
                        }}
                    />
                </Form.Item>
                <div className="grid grid-cols-2 gap-6">
                    <div>
                        <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                            Door
                        </h1>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                name="doorColor"
                                label={'Color'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[120px]"
                                    isColor={true}
                                    value={form.getFieldValue('doorColor')}
                                    options={doorColorOptions}
                                    onChange={(value) => {
                                        form.setFieldValue('doorColor', value);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="doorStyle"
                                label={'Style'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[75px]"
                                    value={form.getFieldValue('doorStyle')}
                                    options={doorStyleOptions}
                                    onChange={(value) => {
                                        form.setFieldValue('doorStyle', value);
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div>
                        <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                            Handle
                        </h1>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                name="handleColor"
                                label={'Color'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[150px]"
                                    isColor={true}
                                    value={form.getFieldValue('handleColor')}
                                    options={handleColorOptions}
                                    onChange={(value) => {
                                        form.setFieldValue(
                                            'handleColor',
                                            value,
                                        );
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="handleStyle"
                                label={'Style'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[75px]"
                                    value={form.getFieldValue('handleStyle')}
                                    options={handleStyleOptions}
                                    onChange={(value) => {
                                        form.setFieldValue(
                                            'handleStyle',
                                            value,
                                        );
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                    <div>
                        <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                            Drawer
                        </h1>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                name="drawerColor"
                                label={'Color'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[120px]"
                                    isColor={true}
                                    value={form.getFieldValue('drawerColor')}
                                    options={drawerColorOptions}
                                    onChange={(value) => {
                                        form.setFieldValue(
                                            'drawerColor',
                                            value,
                                        );
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="drawerStyle"
                                label={'Style'}
                                className="custom-form-item mt-[8px]">
                                <CustomDropdown
                                    className="mt-2"
                                    rootClassName="h-[48px]"
                                    popupClassName="!h-[75px]"
                                    value={form.getFieldValue('drawerStyle')}
                                    options={drawerStyleOptions}
                                    onChange={(value) => {
                                        form.setFieldValue(
                                            'drawerStyle',
                                            value,
                                        );
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div>
                        <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                            Rod
                        </h1>
                        <Form.Item
                            name="rodColor"
                            label={'Color'}
                            className="custom-form-item mt-[8px]">
                            <CustomDropdown
                                className="mt-2"
                                rootClassName="h-[48px]"
                                popupClassName="!h-[150px]"
                                isColor={true}
                                value={form.getFieldValue('rodColor')}
                                options={rodColorOptions}
                                onChange={(value) => {
                                    form.setFieldValue('rodColor', value);
                                }}
                            />
                        </Form.Item>
                    </div>
                </div>
                <div>
                    <h1 className="font-favorit text-[20px] font-[700] leading-[28px]">
                        Additional options
                    </h1>
                    <div className="grid grid-cols-4">
                        <Form.Item
                            name="legs"
                            label="Legs"
                            rootClassName="Checkbox-item"
                            className="custom-form-item mt-[8px]"
                            valuePropName="checked">
                            <Checkbox className="custom-checkbox" />
                        </Form.Item>
                        <Form.Item
                            name="shelf"
                            label="Shelf"
                            rootClassName="Checkbox-item"
                            className="custom-form-item mt-[8px]"
                            valuePropName="checked">
                            <Checkbox className="custom-checkbox" />
                        </Form.Item>{' '}
                        <Form.Item
                            name="topDoors"
                            label="Top Doors"
                            rootClassName="Checkbox-item"
                            className="custom-form-item mt-[8px]"
                            valuePropName="checked">
                            <Checkbox className="custom-checkbox" />
                        </Form.Item>{' '}
                        <Form.Item
                            name="bottomDoors"
                            label="Bottom Doors"
                            rootClassName="Checkbox-item"
                            className="custom-form-item mt-[8px]"
                            valuePropName="checked">
                            <Checkbox className="custom-checkbox" />
                        </Form.Item>
                    </div>
                </div>
            </div>
            <Button
                onClick={onNext}
                label={'Continue to Project Setup'}
                className={
                    'absolute bottom-[16px] right-[0px]  bg-theme-orange text-theme-white hover:bg-theme-orange-hover'
                }
            />
        </div>
    );
});

export default ClosetStyle;
